import React, {useState} from "react";
import VerificationComplete from "./VerificationComplete";
import VerificationFormContainer from "./VerificationFormContainer";
import {translate} from "@mediaspace/shared/utils";
import VerificationProps from "./VerificationProps";
import {BodyText, InnerContainer, Title, Wrapper} from "@mediaspace/shared/ui/status-screen/CommonMessageStyles";

/**
 * Component to handle email verification during site registration process
 */
export function Verification({
                                 recaptchaSiteKey,
                                 recaptchaTheme = "light",
                                 recapthcaMode,
                                 completeTitle,
                                 completeDescriptionHtml,
                                 submitUrl,
                             }: VerificationProps) {
    const [sent, setSent] = useState(false);

    const handleSubmit = () => {
        setSent(true);
    };

    return (
            <Wrapper className="siteRegistration">
                <InnerContainer className="kms-ds-registration-verification-content">
                    {sent && (
                        <VerificationComplete
                            completeTitle={completeTitle}
                            completeDescriptionHtml={completeDescriptionHtml}
                        />
                    )}
                    {!sent && (
                        <>
                            <Title variant={"h2"} component={"h1"} className="siteRegistration-complete-title">
                                {translate("Send Activation Email")}
                            </Title >
                            <BodyText align={"center"} variant={"body1"} >
                                {translate(
                                    "Enter your email address to resend the activation email."
                                )}
                            </BodyText>
                            <div >
                                <VerificationFormContainer
                                    recaptchaSiteKey={recaptchaSiteKey}
                                    recaptchaTheme={recaptchaTheme}
                                    recapthcaMode={recapthcaMode}
                                    onSubmit={handleSubmit}
                                    submitUrl={submitUrl}
                                />
                            </div>
                        </>
                    )}
                </InnerContainer>
            </Wrapper>
    );
}

export default Verification;
